import {AuthService, OrderService, ErrorHandler} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    name: 'payment',
    data () {
        return {
            msg: 'Payments',
            items: [],
            errors: [],
            txnToken: this.$route.query.txnToken,
            paymentType: this.$route.params.paymentType,
            amount: null,
            bookingNum: null,
            bookingId:null,
            cinemaId: null,
            bookingCinemaId: null,
            vistaSessionId: null,
            vistaAmount: null,
            ticketCode: null,
            userSessionId: null,
            loggedInUser: null,
            paymentError: {extendedResultCode: undefined, errorDescription: "", Result: undefined},
            loading: true,
        }
    },
    methods: {
        validatePayment(){
            AuthService.getUserOrderInfo().then((user)=> {

                // console.log("route.query",this.$route.query)
                let payload = {
                    TxnToken: this.$route.query.token,
                    TransactionId: this.$route.query.transaction_id,
                    TransactionStatus: this.$route.query.success,
                    CustomerName: user.FullName,
                    CustomerPhone: user.MobilePhone,
                    CustomerEmail: user.Email,
                };
                // console.log("payload",payload)
                ErrorHandler.ignoreNextError()
                if(this.amount === null) {
                    OrderService.completeOrder(payload).then(
                        (booking)=> {
                            // console.log("payment booking",booking)
                            // console.log(`/booking-successful/${booking.bookingId}/${booking.bookingNumber}/${booking.cinemaId}`)
                            // console.log("BOOKING",booking);
                            if(booking === undefined){
                              this.$router.push(`/booking-unsuccessful`)
                            }else{
                              //use href to update points so the system is forced to re-request the user and get their points.
                              window.location.href = `/booking-successful/${booking.bookingId}/${booking.bookingNumber}/${booking.CinemaId}`;
                            }
                        }
                    );
                } else {
                    Promise.resolve(OrderService.getBooking(this.bookingNum, this.bookingId, this.bookingCinemaId)).then(
                        (booking) => {
                            // console.log("booking",booking, this.bookingNum, this.bookingId, this.bookingCinemaId)
                            if(booking === undefined) {
                                this.$router.push('/booking-unsuccessful')
                            } else {
                                window.location.href = `/booking-successful/${this.bookingNum}/${this.bookingId}/${this.bookingCinemaId}`
                            }
                        }
                    )
                }
            })
        },
    },
    created() {
        this.loading = true;
        if(this.$route.query.amount) {
            this.amount = this.$route.query.amount
        }

        if(this.$route.query.bookingNum) {
            this.bookingNum = this.$route.query.bookingNum
        }

        if(this.$route.query.bookingId) {
            this.bookingId = this.$route.query.bookingId
        }

        if(this.$route.query.cinemaId) {
            this.bookingCinemaId = this.$route.query.cinemaId
        }


    },
    mounted()
    {
        this.validatePayment();

    }

}



// WEBPACK FOOTER //
// ./src/components/pages/payment/payment.js